var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333332;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "about"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,8c2.1,0,3.8-1.7,3.8-3.8S10.1,0.4,8,0.4S4.2,2.1,4.2,4.2S5.9,8,8,8z M8,1.5c1.5,0,2.7,1.2,2.7,2.7 S9.5,6.9,8,6.9S5.3,5.7,5.3,4.2S6.5,1.5,8,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,9.1H7.5c-3.3,0-6,2.7-6,6c0,0.3,0.2,0.5,0.5,0.5h12c0.3,0,0.5-0.2,0.5-0.5C14.6,11.8,11.9,9.1,8.5,9.1z  M2.6,14.6c0.3-2.5,2.4-4.4,4.9-4.4h1.1c2.5,0,4.6,1.9,4.9,4.4H2.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.b9c43bf3338041e14c472b96f4900ba5.svg";
export { ForwardRef as ReactComponent };